
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.676 10.426l-7.988 7.989c-1.74 1.739-4.513 1.794-6.184.123-1.671-1.671-1.616-4.445.123-6.184l7.988-7.989c1.043-1.043 2.708-1.076 3.71-.073 1.003 1.002.97 2.667-.073 3.71L9.262 15.99c-.348.348-.902.36-1.237.025-.334-.334-.323-.889.025-1.237l7.988-7.988-1.212-1.212-7.988 7.988c-1.043 1.043-1.077 2.708-.074 3.71 1.003 1.003 2.667.97 3.71-.073l7.989-7.989c1.739-1.739 1.794-4.513.123-6.184-1.671-1.67-4.445-1.615-6.184.123l-7.989 7.989c-2.434 2.434-2.511 6.318-.172 8.657 2.34 2.34 6.224 2.262 8.658-.172l7.988-7.988-1.212-1.213z","fill":"#F38B00"}})])
          )
        }
      }
    